const applicationConfig = {
    CONSUMER_CF_DISTRO: process.env.VUE_APP_CONSUMER_CF_DISTRO,
    GOOGLE_PLACES_API_KEY: process.env.VUE_APP_GOOGLE_PLACES_API_KEY,
    ANALYTICS_SESSION_TIMEOUT_MINUTES: 30,
    SAVED_SESSION_TIMEOUT_DAYS: 45,
    COOKIE_PATH: "/",
    CURRENT_ENVIRONMENT: process.env.VUE_APP_CURRENT_ENVIRONMENT, // "Localhost", "Dev", "QA", and "Prod"
    HERITAGE_FUNNEL: process.env.VUE_APP_HERITAGE_FUNNEL,
    APPLICATION_NAME: "FixMyGlass",
    ANALYTICS_APPLICATION_NAME: "FixMyGlassNextGen",
    APPLICATION_ABBREVIATION: "fmg",
    PAGE_QUERYSTRING: "fmgPage",
    SITE_ENTRY_TRIGGER_VALUE: "FixMyGlass",
    CASH_PARENT_ACCOUNT_NUMBER: 167132,
    CASH_DEFAULT_BILL_TO_ACCOUNT_NUMBER: "87291",
    MY_ACCOUNT: process.env.VUE_APP_MY_ACCOUNT,
    PIA_RESPONSE_URL:
        location.protocol +
        "//" +
        location.host +
        "/fmg/?fmgPage=payment-pia-return&src=concept-funnel",
    PIA_CANCEL_URL:
        location.protocol +
        "//" +
        location.host +
        "/fmg/?fmgPage=payment-method&src=concept-funnel",
    PIA_ERROR_URL:
        location.protocol +
        "//" +
        location.host +
        "/fmg/?fmgPage=payment-pia-return&src=concept-funnel",
    CONFIRMATION_URL: location.protocol + "//" + location.host + "/fmg/?fmgPage=confirmation",
    GOOGLE_CALENDAR: "https://www.google.com/calendar/render?action=TEMPLATE",
    YAHOO_CALENDAR: "https://calendar.yahoo.com/?v=60",
    OUTLOOK_CALENDAR:
        "https://outlook.office.com/calendar/deeplink/compose?path=/calendar/action/compose&rru=addevent",
    FRONTEND_LOGGER_PATH: "/analytics/api/v1/logging",
    AFFILIATE_COOKIE_CONTAINING_NAME: "_Track",
    COOKIE_NAME_LENGTH_MAX_LIMIT: 44,
    SESSION_TIMEOUT_MINUTES: process.env.VUE_APP_SESSION_TIMEOUT_MINUTES,
    RETURN_USER_PAGE: "/fmg/?fmgPage=return-user",
};

export { applicationConfig };
